<template>
  <button
    ref="showMoreItemsButton"
    class="link/focus"
    @click="showMoreItems($event)"
    >
    <p
      class="typography"
      v-html="showMoreItemsButtonHtml"
    />
  </button>
</template>

<script>
export default {
  name: 'paginated-list-controls',
  props: {
    showMoreItemsButtonHtml: {
      type: String,
      required: true,
    },
    currentPage: {
      type: Number,
      required: true,
    },
  },
  methods: {
    showMoreItems: function(event) {
      if (event)
        event.preventDefault();

      this.$emit('fetch-paginated-items');
    }
  }
};
</script>
